import React from "react"
import { Card, CardBody, ListGroup, ListGroupItem, Badge } from "reactstrap"
import { Link } from "react-router-dom"

const PendingTasks = () => {
  // Dummy data for pending tasks - replace with real API data later
  const pendingTasks = [
    {
      id: 1,
      title: "KYC Documents Review",
      description: "23 users pending verification",
      priority: "high",
      link: "/kyc",
      icon: "mdi mdi-file-document",
      count: 23
    },
    {
      id: 2,
      title: "Business Claim Requests",
      description: "8 business verification requests",
      priority: "medium",
      link: "/Claim-requests",
      icon: "mdi mdi-domain",
      count: 8
    },
    {
      id: 3,
      title: "Payment Disputes",
      description: "5 transaction disputes to resolve",
      priority: "high",
      link: "/transactions",
      icon: "mdi mdi-alert-circle",
      count: 5
    },
    {
      id: 4,
      title: "Email Template Updates",
      description: "3 templates need review",
      priority: "low",
      link: "/EmailTemplateTable",
      icon: "mdi mdi-email",
      count: 3
    },
    {
      id: 5,
      title: "User Reports",
      description: "12 user reports to investigate",
      priority: "medium",
      link: "/user-list",
      icon: "mdi mdi-flag",
      count: 12
    }
  ]

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'danger'
      case 'medium': return 'warning'
      case 'low': return 'info'
      default: return 'secondary'
    }
  }

  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'high': return 'mdi-arrow-up'
      case 'medium': return 'mdi-minus'
      case 'low': return 'mdi-arrow-down'
      default: return 'mdi-minus'
    }
  }

  return (
    <Card>
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h4 className="card-title">Pending Tasks</h4>
          <Badge color="danger" className="badge-soft">
            {pendingTasks.reduce((sum, task) => sum + task.count, 0)} Total
          </Badge>
        </div>

        <ListGroup flush>
          {pendingTasks.map((task) => (
            <ListGroupItem key={task.id} className="border-0 px-0">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className={`avatar-sm rounded-circle bg-${getPriorityColor(task.priority)} d-flex align-items-center justify-content-center me-3`}>
                    <i className={`${task.icon} text-white`}></i>
                  </div>
                  <div>
                    <h6 className="mb-1">{task.title}</h6>
                    <p className="text-muted mb-0 font-size-13">{task.description}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <Badge color={getPriorityColor(task.priority)} className="badge-soft">
                    <i className={`mdi ${getPriorityIcon(task.priority)} me-1`}></i>
                    {task.priority}
                  </Badge>
                  <Badge color="primary" className="rounded-pill">
                    {task.count}
                  </Badge>
                  <Link to={task.link} className="btn btn-sm btn-outline-primary">
                    <i className="mdi mdi-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </ListGroupItem>
          ))}
        </ListGroup>

        <div className="text-center mt-3">
          <small className="text-muted">
            Last updated: {new Date().toLocaleTimeString()}
          </small>
        </div>
      </CardBody>
    </Card>
  )
}

export default PendingTasks